import axios from "axios";
import { Message } from "../utils/Message";

/**
 * Dodaje nowy obszar do bazy Age i zwraca utworzony obiekt cechy (feature).
 *
 * Funkcja wysyła zapytanie POST do API oraz formatuje współrzędne obszaru.
 * Oprócz zapisu wyniku w sessionStorage (dla zgodności ze starszą logiką),
 * funkcja zwraca również bezpośrednio wynik operacji, co umożliwia dalszą pracę
 * na zwróconym obiekcie bez konieczności odczytywania danych z sessionStorage.
 *
 * @param {Array} coordinates - Współrzędne obszaru w formacie [[x, y], ...].
 * @param {number|string} id - Identyfikator żądania.
 * @param {string} code - Kod żądania.
 * @param {string} area_name - Nazwa obszaru.
 * @returns {Promise<Object|null>} - Obiekt responseFeature (GeoJSON) lub null, jeśli operacja się nie powiodła.
 */

const handleAddNewAreaToAge = async (coordinates, id, code, area_name) => {

    // Funkcja pomocnicza konwertująca tablicę na string zachowując zagnieżdżenie
    const arrayToString = (arr) => {
        if (Array.isArray(arr)) {
            return "[" + arr.map(arrayToString).join(", ") + "]";
        } else {
            return arr.toString();
        }
    };

    const resultString = arrayToString(coordinates);

    try {
        const response = await axios.post(
            `https://api.lightpass.gradis.pl/api/requests/${id}/${code}/areas`,
            { 
                name: area_name,
                geojson: `{ "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ${resultString} }, "properties": { "name": "${area_name}" } }`
            },
            {
                headers: {
                    'Accept-Language': localStorage.getItem("language") || "pl"
                }
            }
        );

        console.log("Add new area to age response: ", response);
        return response;
    } catch (error) {
        console.error("Error while adding new area to age: ", error);
        sessionStorage.setItem("responseFeature", JSON.stringify(null));
        Message.show(error.message, Message.severity.ERROR);
        return null;
    }
};

export default handleAddNewAreaToAge;
